import { render, staticRenderFns } from "./Overspeed.vue?vue&type=template&id=6c6b4976&scoped=true&lang=pug"
import script from "./Overspeed.vue?vue&type=script&lang=js"
export * from "./Overspeed.vue?vue&type=script&lang=js"
import style0 from "./Overspeed.vue?vue&type=style&index=0&id=6c6b4976&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b4976",
  null
  
)

export default component.exports